import { render } from "./ProcessoConsultaComponent.vue?vue&type=template&id=679ede16&scoped=true"
import script from "./ProcessoConsultaComponent.vue?vue&type=script&lang=js"
export * from "./ProcessoConsultaComponent.vue?vue&type=script&lang=js"

import "./ProcessoConsultaComponent.vue?vue&type=style&index=0&id=679ede16&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679ede16"]])

export default __exports__